import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["color", "text"]

  connect() {
    this.sync()
  }

  colorChanged() {
    this.textTarget.value = this.colorTarget.value
  }

  textChanged() {
    const value = this.textTarget.value
    // Validate hex color format
    if (/^#[0-9a-fA-F]{6}$/.test(value)) {
      this.colorTarget.value = value
    }
  }

  sync() {
    if (this.hasColorTarget && this.hasTextTarget) {
      if (this.colorTarget.value) {
        this.textTarget.value = this.colorTarget.value
      }
    }
  }
}
